
define(
	'Code25.CaterpartsGlobal.OEMMatch.View'
	, [
		"Handlebars", "Utils", "Code25.oemmatch.tpl"
	]
	, function (
		Handlebars, Utils, Code25_oemmatch_tpl
	) {
		'use strict';




		return Backbone.View.extend({

			template: Code25_oemmatch_tpl,
			initialize: function (options) {

			},

			getMatches: function () {

				if (sessionStorage) {
					var matched = {};
					try {
						matched = JSON.parse(sessionStorage.getItem("matched") || "{}");
					} catch (err) { }
					return matched;
				} else {
					window.matched = window.matched || {};
					return window.matched;
				}
			}
			,

			getContext: function getContext() {
				
				var item = this.model.get("item");
				var res={};
				if (item) {

					var searchkeywords = item.get("searchkeywords");

					if (searchkeywords) {
						var matches = this.getMatches();
						var search = searchkeywords.toLowerCase().split(" ");
						for (var i = 0; i < search.length; i++) {
							if (matches[search[i]]) {
								res= { match: search[i].toUpperCase() };
								break;
							}
						}
					}
				}
				if(this.options.pdp){
					this.options.pdp.setOption("custcol_c25_oemcode",res.match||"");
				}
				
				return res;
			}
		});

	});
